module.exports = __webpack_public_path__ + "img/card1.e1709a2f.png";